import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { defineComponent, ref, computed, watch, } from 'vue';

// icons
import { add, close } from 'ionicons/icons';

// components
import {
  IonPage,
  IonGrid,
  IonCard,
  IonInput,
  IonIcon,
  IonFooter,
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonTitle,
  IonSearchbar,
  IonToolbar,
  modalController,
  loadingController
} from '@ionic/vue';

import config from '@/config';
import { utils } from '@/composables/utils';
import { useStore } from '@/store';

import TeacherService from '@/services/TeacherService';


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleInSchoolSelectModal',
  props: ["hideHeader", "selectedRolesInSchool"],
  setup(__props) {

// vue
const props = __props;

const { closeModal, presentToast } = utils();
const store = useStore();
const user = computed(() => store.state.user);
const userSchoolRoles = computed(() => ((user.value.teacher?.schoolRoles || "").split(" , ").filter(r => r)));

const searchKeyword = ref("");

const workingSelectedValues = ref([...(props.selectedRolesInSchool || userSchoolRoles.value)]);
const rolesInSchool = ref([...new Set(workingSelectedValues.value.concat(config.formOptions.rolesInSchool))]);

const isChecked = (value: string) => {
  return workingSelectedValues.value.find((item) => item === value) !== undefined;
};

const confirmChanges = async () => {
  if (props.hideHeader) { // from TeacherRolesModal
    const updateSchoolRoles = workingSelectedValues.value.join(" , ");

    const loading = await loadingController.create({});
    await loading.present();

    // Check remove class roles (set status to removed)
    TeacherService.updateTeacher(user.value, { schoolRoles: updateSchoolRoles });
    store.commit('updateTeacher', { schoolRoles: updateSchoolRoles });
    presentToast("Saved successfully!");

    loading.dismiss();
  }
  else {
    await modalController.dismiss({ workingSelectedValues })
  }
};
const checkboxChange = (ev) => {
  const { checked, value } = ev.detail;
  if (checked){
    workingSelectedValues.value.push(value)
  } else {
    workingSelectedValues.value = workingSelectedValues.value.filter(role => role!= value)
  }
};
const onAddNewRole = () => {
  if (searchKeyword.value) {
    workingSelectedValues.value.unshift(searchKeyword.value.trim());
    searchKeyword.value = '';
    rolesInSchool.value = [...new Set(workingSelectedValues.value.concat(config.formOptions.rolesInSchool))];
  }
};

// Watch (direct page access)
watch(user, () => {
  if (!props.selectedRolesInSchool) workingSelectedValues.value = [...(userSchoolRoles.value)];
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { fixed: "" }, {
            default: _withCtx(() => [
              (!__props.hideHeader)
                ? (_openBlock(), _createBlock(_unref(IonToolbar), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonTitle), null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Select your position(s) in the school")
                        ])),
                        _: 1,
                        __: [5]
                      }),
                      _createVNode(_unref(IonButtons), { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            slot: "icon-only",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(closeModal)()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    lines: "none",
                    fill: "outline"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_unref(IonButton), {
                        slot: "start",
                        size: "normal",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onAddNewRole()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: _unref(add)
                          }, null, 8, ["icon"]),
                          _cache[6] || (_cache[6] = _createTextVNode(" Add "))
                        ]),
                        _: 1,
                        __: [6]
                      }, 512), [
                        [_vShow, searchKeyword.value]
                      ]),
                      _createVNode(_unref(IonInput), {
                        type: "text",
                        modelValue: searchKeyword.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchKeyword).value = $event)),
                        placeholder: "Type here if your position is not listed"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCard), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonList), { style: {"max-height":"65vh","overflow-y":"scroll"} }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rolesInSchool.value, (role) => {
                        return (_openBlock(), _createBlock(_unref(IonItem), {
                          key: role,
                          button: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCheckbox), {
                              "label-placement": "end",
                              justify: "start",
                              value: role,
                              checked: isChecked(role),
                              onIonChange: _cache[3] || (_cache[3] = ($event: any) => (checkboxChange($event)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(role), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "checked"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButton), {
                color: "success",
                expand: "block",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (confirmChanges()))
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Confirm ")
                ])),
                _: 1,
                __: [7]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})